import gettingYourOrder from './getting-your-order';
import paymentOptions from './payment-options';

export default function index() {
  gettingYourOrder();
  paymentOptions();
}
